import Vue from "vue";
import config from "@/common/config";
import platformList from "@/common/platformMap.js";
import { mapState } from "vuex";
import axios from "axios";
import OSS from 'ali-oss';
var mixins = {
  data() {
    return {
      commonConfigs: config,
    };
  },
  computed: {
    ...mapState({
      dldId: (state) => state.common.dldId, //雷达id
      buildType: (state) => state.common.buildType, //打包类型  站内|1688Web  站外|App
      userInfo: (state) => state.users.userInfo,
      applyShopList: (state) => state.common.applyShopList,
      selectPlatForm: (state) => state.common.applySelected.platform,
      selectShopId: (state) => {
        let applySelected = state.common.applySelected;
        return applySelected.shopId[applySelected.platform]
      },
      fullscreenBody: (state) => state.common.fullscreen, //全屏状态
    }),
    allApplyShopList() {
      // 计算总共申请店铺数量
      let list = [];
      this.applyShopList.forEach((item) => {
        list = list.concat(item.shopList);
      });
      return list;
    },
    applyShopCount() {
      return this.allApplyShopList.length;
    },
  },
  methods: {
    async directUploadOSS(file, dir = 'market', maxRetry = 3) {
      const isVideoFile = (f) => {
        if (typeof f === 'string') return false;
        const name = f.name || '';
        const type = f.type || '';
        return /\.(mp4|webm|mov|avi|flv|wmv|mkv|3gp|m4v)$/i.test(name) ||
          type.startsWith('video/');
      };

      const ext = typeof file === 'string'
        ? (file.match(/^data:image\/(\w+);base64/)?.[1] || 'png')
        : (file.name?.split('.').pop() || 'png');

      const targetDir = isVideoFile(file) ? 'video' : dir;
      const ossFileName = `${targetDir}/${Date.now()}.${ext}`;

      let fileData;
      if (typeof file === 'string') {
        const base64Data = file.replace(/^data:.*?;base64,/, '');
        const binaryString = atob(base64Data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        fileData = new Blob([bytes], { type: file.match(/^data:(.*?);/)?.[1] || 'application/octet-stream' });
      } else {
        fileData = file.rawFile || file;
      }

      const client = new OSS({
        region: 'oss-cn-zhangjiakou',
        accessKeyId: 'LTAI5tCnFJi6Tuqe1du5ddfp',
        accessKeySecret: 'Q1bmAItXrefFGZL208GQoz1buPD49e',
        bucket: 'kjfxzb',
      });

      let lastError;

      for (let i = 0; i < maxRetry; i++) {
        try {
          const result = await client.put(ossFileName, fileData);
          return `https://oss.dianleida.net/${ossFileName}`;
        } catch (err) {
          lastError = err;
          console.error(`Upload attempt ${i + 1} failed:`, err);
          if (i < maxRetry - 1) {
            await new Promise(r => setTimeout(r, 1000 * (i + 1)));
          }
        }
      }

      throw lastError;
    },
    uploadOssVideo2(file) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64 = reader.result;
            this.$ajax.post("https://fxupload.dianleida.net:20081/upload/common/uploadVideo2", {
              file: base64
            })
              .then((res) => {
                if (res.code !== 200) {
                  this.$message.error(res?.msg || "视频文件上传失败");
                  return reject();
                }
                resolve(res.result);
              })
              .catch(() => {
                reject();
              });
          };
          reader.onerror = () => {
            reject();
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    uploadOssVideo(file) {
      const formData = new FormData();
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        try {
          this.$ajax.post("https://fxupload.dianleida.net:20081/upload/common/uploadVideo", formData)
            .then((res) => {
              if (res.code !== 200) {
                this.$message.error(res?.msg || t("视频文件上传失败"));
                return reject();
              }
              resolve(res.result);
            })
            .catch(() => {
              reject();
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    uploadOssImage(file) {
      return new Promise((resolve) => {
        this.$ajax
          .post("https://fxupload.dianleida.net:20081/upload/common/uploadImg", {
            file,
          })
          .then((res) => {
            if (res.code !== 200) {
              return this.$message.error(res.msg);
            }
            resolve(res.result);
          });
      });
    },
    uploadTemuImage({ shopId, url }) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post("/product/temu/goodsImageUpload", {
            shopId,
            url,
            platform: this.$store.state.common.applySelected.platform,
          })
          .then((res) => {
            if (res.code !== 200) {
              this.$message.error(res.msg);
              return reject(res);
            }
            resolve(res.result.imageUrl);
          })
          .catch(() => {
            reject();
          });
      });
    },
    fillBackOssImages(imgList, callBack) {
      this.$bus.$emit("meitu", {
        data: imgList,
        callBack: async (imgBack) => {
          let imgs = [];
          let Imglength = imgBack.length;
          this.$bus.$emit("progress", {
            type: "show",
            text: `正在上传图片${imgs.length}/${Imglength}，请耐心等待...`,
          });
          for (let item of imgBack) {
            await this.$utils.blobToBase64(item, async (base64) => {
              let resImg = await this.directUploadOSS(base64);
              imgs.push(resImg);
              let text = `正在上传图片${imgs.length}/${Imglength}，请耐心等待...`;
              let percentage = Math.round((imgs.length / Imglength) * 100);
              this.$bus.$emit("progress", { type: "update", text, percentage });
            });
          }
          callBack && callBack(imgs);
        },
      });
    },
    tableIndexShow(index) {
      const { pageSize, pageIndex } = this.pageData;
      let difIndex = pageSize * (pageIndex - 1) + index + 1;
      return difIndex < 10 ? `0${difIndex}` : difIndex;
    },
    getPlatformData(platform) {
      // 获取平台的数据
      if (!platform) return "";
      return (
        platformList.find(
          (item) => item.code.toLowerCase() === platform.toLowerCase(),
        ) || ""
      );
    },
    buryingPoint({ functionName, source }) {
      // 埋点
      this.$ajax
        .post("/BuryingPoint/Add", { functionName, source })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
        });
    },
    getPlatformName(platform) {
      // 获取平台的名称
      let platformName =
        platformList.find((v) => v.code === platform)?.nameEn || platform;
      return platformName;
    },
    // 获取菜单路由的名称
    getPathName(path) {
      let pathLastName = path.split("/").pop();
      let routerList = this.$router.options.routes[0]?.children || [];
      let functionName = routerList.find((item) =>
        item.path.includes(`/${pathLastName}`),
      ).name;
      return functionName;
    },
    // 货源账号授权授权弹窗
    checkingSupplyAccount(dldId) {
      const h = this.$createElement;
      this.$msgbox({
        title: "授权提示",
        message: h("div", { class: "auth-dialog-content" }, [
          h(
            "p",
            { style: "margin: 10px 0; line-height: 1.5; color: #606266;" },
            "应1688要求，请授权1688货源账号后再进行采集，授权后采集更稳定，更快速!",
          ),
          h("div", { class: "auth-footer-custom" }, [
            // 左侧联系客服
            h(
              "el-popover",
              {
                props: { placement: "left", trigger: "hover", width: "160" },
              },
              [
                h("div", { style: "text-align: center" }, [
                  h(
                    "p",
                    { style: "margin: 0 0 10px; font-size: 12px;" },
                    "打开微信扫一扫添加客服",
                  ),
                  h("img", {
                    attrs: { src: "//oss.dianleida.net/1688-web/images/kefu.jpg" },
                    style: "width: 120px; height: 120px;",
                  }),
                ]),
                h("div", { slot: "reference", class: "contact-service" }, [
                  h("i", {
                    class: "dfx-iconfont icon-weixin",
                    style:
                      "color: #1aad19; margin-right: 5px; font-size: 18px;",
                  }),
                  h(
                    "span",
                    { style: "color: #1aad19; cursor: pointer;" },
                    "联系客服",
                  ),
                ]),
              ],
            ),
            // 右侧立即授权按钮
            h(
              "el-button",
              {
                props: { type: "success" },
                on: {
                  click: () => {
                    this.toAuthUrl(dldId);
                    this.$msgbox.close();
                  },
                },
                style: "background-color: #00c853; border-color: #00c853;",
              },
              "立即授权",
            ),
          ]),
        ]),
        showConfirmButton: false, // 隐藏默认按钮，使用自定义布局
        customClass: "custom-auth-box",
      }).catch(() => { });
    },
    toAuthUrl(dldId) {
      // 跳转货源授权页
      this.$ajax
        .post("/user/sourceAccount/getAuthUrl", {
          dldId,
        })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          window.open(res.result, "_blank");
          let timer = setTimeout(() => {
            this.$confirm("是否已完成1688货源账号授权？", "提示", {
              confirmButtonText: "已完成授权",
              cancelButtonText: "未完成授权",
              closeOnClickModal: false,
              type: "warning",
            })
              .then(() => {
                this.$message.success("1688货源账号已授权成功");
                timer = setTimeout(() => {
                  dldId ? this.postRefreshMsg() : location.reload();
                  clearTimeout(timer);
                }, 1000);
              })
              .catch((action) => {
                location.reload();
              });
          }, 1000);
        });
    },
    postRefreshMsg() {
      // 解绑后刷新父窗口
      window.parent.postMessage(
        {
          type: "dfxRefresh",
          reason: "userAction",
        },
        "*",
      );
    },
    getSellerData(sellerOpenId) {
      // 获取卖家信息
      return new Promise((resolve, reject) => {
        this.$ajax
          .get(
            `/order/purchaseOrder/wangwangDataGet?sellerOpenId=${sellerOpenId}`,
          )
          .then((res) => {
            if (res.code === 200) {
              resolve(res.result);
            } else {
              reject(res);
            }
          });
      });
    },
    // 打开卖家旺旺
    async openWangwang(item) {
      let url = item.sellerUrl;
      if (!url) {
        await this.getSellerData(item.sellerOpenId).then((res) => {
          url = res.url;
        });
      }
      window.open(url, "_blank");
    },
    // 获取运费
    getFreightEstimate({
      offerIds,
      toProvinceCode,
      toCityCode,
      toCountryCode,
      totalNum = 1,
    }) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post("/order/purchaseOrder/freightEstimate", {
            offerIds,
            toProvinceCode,
            toCityCode,
            toCountryCode,
            totalNum,
          })
          .then((data) => {
            if (data.code === 200) {
              resolve(data.result);
            } else {
              resolve([]);
            }
          });
      });
    },
    // 整理商品信息展示
    getGoodsInfo(goodInfo) {
      let {
        productImage,
        productSaleInfo,
        productSkuInfos,
        productShippingInfo,
      } = goodInfo;
      let price = "";
      if (productSaleInfo && productSaleInfo.priceRangeList) {
        let length = productSaleInfo.priceRangeList.length;
        if (length > 1) {
          price = `${productSaleInfo.priceRangeList[0].price}~${productSaleInfo.priceRangeList[length - 1].price
            }`;
        } else {
          price = productSaleInfo.priceRangeList[0]?.price;
        }
      }
      let skuList = [];
      if (productSkuInfos && productSkuInfos.length) {
        let {
          height,
          length,
          width,
          weight,
          skuShippingDetails,
          skuShippingInfoList,
        } = productShippingInfo;
        skuList = productSkuInfos.map((item) => {
          if (!height || !length || !width) {
            let skuShippingInfo = null;
            if (skuShippingInfoList) {
              skuShippingInfo = skuShippingInfoList.find(
                (v) => v.skuId == item.skuId,
              );
            } else if (skuShippingDetails) {
              skuShippingInfo = skuShippingDetails.find(
                (v) => v.skuId == item.skuId,
              );
            }
            if (skuShippingInfo) {
              height = skuShippingInfo.height;
              length = skuShippingInfo.length;
              width = skuShippingInfo.width;
              weight = skuShippingInfo.weight;
            }
          }
          return {
            ...item,
            skuName: item.skuAttributes.map((v) => v.value).join("，"),
            height: height ? height.toFixed(2) : "-",
            length: length ? length.toFixed(2) : "-",
            width: width ? width.toFixed(2) : "-",
            weight: weight ? weight.toFixed(2) : "-",
            volume:
              height && height !== "-"
                ? (height * length * width).toFixed(2)
                : "-",
          };
        });
      }
      let infoData = {
        ...goodInfo,
        imageUrl: productImage?.images[0] || "",
        price,
        freight: "",
        skuList,
      };
      return infoData;
    },
    // 获取三方物流
    getLogisticsTemplate() {
      return new Promise(async (resolve, reject) => {
        this.$ajax.post("/logistics/getAllAuthChannel", {
          type: 1,
          platform: "TEMU",
        })
          .then((res) => {
            if (res.code !== 200) {
              this.$message.error(res.msg);
              return reject(res);
            }
            resolve(res.result);
          });
      });
    },
    // 获取类目详情
    async getCateIdInfo({ catId, platform, shopId }) {
      return new Promise(async (resolve, reject) => {
        this.$ajax
          .get("/product/temu/getCategoryById", {
            params: {
              id: catId,
              platform: platform || this.selectPlatForm,
              shopId,
            },
          })
          .then((res) => {
            resolve(res);
          });
      })
    },
    // 获取类目数据
    getCateAttrToRender({ shopId, catId, platform, callBack }) {
      return new Promise(async (resolve, reject) => {
        this.$ajax
          .post("/product/temu/attrsGet", {
            shopId, catId, platform
          })
          .then((res) => {
            if (res.code !== 200) {
              reject(res);
              return this.$message.error(res.msg);
            }
            let propsSale = [];
            let propsAttr = [];
            let autoPropsAttr = [];
            let autoIds = new Set();
            // 过滤商品属性和销售属性
            res.result.properties.forEach((v) => {
              if (v.isSale) {
                propsSale.push(v);
              } else if (
                v.values &&
                v.values.find((p) => p.parentVidList && p.parentVidList.length)
              ) {
                v.values.forEach((p) => {
                  if (p.parentVidList && p.parentVidList.length) {
                    autoIds = autoIds.add(...p.parentVidList);
                  }
                });
                autoPropsAttr.push(v);
              } else {
                propsAttr.push(v);
              }
            });
            let resultData = {
              propsSale,
              propsAttr,
              autoPropsAttr,
              resultData: res.result,
            }
            if (callBack) {
              callBack(resultData);
            }
            resolve(resultData);
          });
      })

    },
  },
};
Vue.mixin(mixins);
